module.exports = __webpack_public_path__ + "media/Loops Keys.c0d67826.wav";